import { Can } from 'providers/casl'
import {
  onAdUnitCreateUpdateDelete,
  onAdUnitFieldsRead,
  onAdUnitUnfilledRecoveryBasicSettingsRead,
  onAdUnitUnfilledRecoveryMultiFormatsRead,
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/adUnit'
import {
  onDomainCustomBranchAlertRead,
  onDomainRichPlacementsFeatureInterstitialEmployeeSettingsRead,
  onDomainRichPlacementsFeatureKWordsEmployeeSettingsRead,
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead,
  onDomainRichPlacementsFrequencyCappingRead,
  onDomainUnfilledRecoveryBaseAdUnitPathRead,
  onDomainUnfilledRecoveryReadPrebidSettingsWarning,
} from '../features/domain'
import {
  onGlobalSetupPriceGeniusRead,
  onGlobalSetupWorkspaceUpdate,
} from '../features/globalSetup/common'
import {
  onGlobalSetupDefaultsPrebidVariableNameRead,
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingRead,
  onGlobalSetupDefaultsRichPlacementsKWordsSiteIdRead,
} from '../features/globalSetup/defaults'
import { onPerformanceAdminOptionReadUpdate } from '../features/performance'
import { onProductStatusReadUpdate, onProductUpdate } from '../features/product'
import { onWorkspaceAccess } from '../features/workspace'

export const onEmployeesOnly = (can: Can) => {
  onAdUnitCreateUpdateDelete(can)
  onAdUnitFieldsRead(can)
  onAdUnitUnfilledRecoveryBasicSettingsRead(can)
  onAdUnitUnfilledRecoveryMultiFormatsRead(can)
  onAdUnitUnfilledRecoveryReadPrebidSettingsWarning(can)
  onDomainCustomBranchAlertRead(can)
  onDomainRichPlacementsFeatureKWordsEmployeeSettingsRead(can)
  onDomainRichPlacementsFeatureInterstitialEmployeeSettingsRead(can)
  onDomainRichPlacementsFeatureMultiAnchorAdUnitConnectionRead(can)
  onDomainRichPlacementsFrequencyCappingRead(can)
  onDomainUnfilledRecoveryBaseAdUnitPathRead(can)
  onDomainUnfilledRecoveryReadPrebidSettingsWarning(can)
  onGlobalSetupDefaultsPrebidVariableNameRead(can)
  onGlobalSetupDefaultsRichPlacementsFrequencyCappingRead(can)
  onGlobalSetupDefaultsRichPlacementsKWordsSiteIdRead(can)
  onGlobalSetupPriceGeniusRead(can)
  onGlobalSetupWorkspaceUpdate(can)
  onPerformanceAdminOptionReadUpdate(can)
  onProductStatusReadUpdate(can)
  onProductUpdate(can)
  onWorkspaceAccess(can)
}
